module.exports = __webpack_public_path__ + "img/redMiceCross.e66b2473.svg";